import React, { useState } from "react";
import { UseFormSetValue, UseFormWatch, Control } from "react-hook-form";
import { Page3FormData } from "../../../pages/owner/store/CreateStorePageThree";
import { useTranslation } from "react-i18next";
import ToggleSwitch from "../../ui/ToggleSwitch";
import TimeInput from "../../ui/Timeinput";
  import { useRef } from "react";



interface Props {
  setValue: UseFormSetValue<Page3FormData>;
  watch: UseFormWatch<Page3FormData>;
  control: Control<Page3FormData>;
  fields: any[];
  activeDays: { [day: string]: boolean };
  toggleDay: (day: string) => void;
  setActiveDays: React.Dispatch<React.SetStateAction<{
    [day: string]: boolean;
}>>
}

const OpeningHoursCombined: React.FC<Props> = ({
  setValue,
  watch,
  control,
  fields,
  activeDays,
  toggleDay,
  setActiveDays
}) => {
  const { t } = useTranslation();
  const [applied, setApplied] = useState(false);


// داخل المكون
const prevValuesRef = useRef<{ [idx: number]: { openTime: string; closeTime: string } }>({});

const handleApplyToggle = () => {
  const firstActiveIdx = fields.findIndex((field) => activeDays[field.day]);
  if (firstActiveIdx === -1) return;

  const firstOpen = watch(`openingHours.${firstActiveIdx}.openTime`);
  const firstClose = watch(`openingHours.${firstActiveIdx}.closeTime`);

  if (!applied) {
    // حفظ القيم الحالية للأيام الأخرى قبل النسخ
    fields.forEach((field, idx) => {
      if (idx === firstActiveIdx) return; // تخطي أول يوم
      prevValuesRef.current[idx] = {
        openTime: watch(`openingHours.${idx}.openTime`) || "",
        closeTime: watch(`openingHours.${idx}.closeTime`) || "",
      };
      setValue(`openingHours.${idx}.openTime`, firstOpen || "");
      setValue(`openingHours.${idx}.closeTime`, firstClose || "");
    });

    // تفعيل كل الأيام
    const allActive: { [day: string]: boolean } = {};
    fields.forEach((f) => (allActive[f.day] = true));
    setActiveDays(allActive);

  } else {
    // استعادة القيم السابقة للأيام الأخرى عند إلغاء Apply
    fields.forEach((field, idx) => {
      if (idx === firstActiveIdx) return; // تخطي أول يوم
      const prev = prevValuesRef.current[idx];
      setValue(`openingHours.${idx}.openTime`, prev?.openTime || "");
      setValue(`openingHours.${idx}.closeTime`, prev?.closeTime || "");
    });
  }

  setApplied(!applied);
};

  return (
    <div className="flex flex-col gap-2 mt-4">
      {/* زر تطبيق للكل */}
      <div className="flex justify-end items-center gap-2 mb-2">
        <span className="text-sm capitalize text-DarkGrey3 font-medium">{t("same_everyday")}</span>
        <ToggleSwitch checked={applied} onChange={handleApplyToggle} />
      </div>

      {/* كل يوم */}
      {fields.map((field, idx) => (
        <div key={field.id} className="flex items-center gap-3">
          {/* زر تفعيل اليوم */}
          <button
            type="button"
            className={`px-3 py-2 min-w-[120px] rounded-2xl ${
              activeDays[field.day] ? "bg-primaryButton text-white" : "bg-LightGrey1"
            }`}
            onClick={() => toggleDay(field.day)}
          >
            {t(field.day)}
          </button>

          {/* مدخلات الوقت تظهر فقط إذا اليوم فعال */}
          {activeDays[field.day] && (
            <>
              <TimeInput control={control} idx={idx} name="openTime" />
              <span>{t('to')}</span>
              <TimeInput control={control} idx={idx} name="closeTime" />
            </>
          )}

        </div>
      ))}
    </div>
  );
};

export default OpeningHoursCombined;
